module.exports = __webpack_public_path__ + "img/stripe.864f6eaa.svg";